<p-panel>
  <app-reactive-form-builder
    #formbuilder
    (formChanges)="formChanges($event[0], $event[1])"
    (goBack)="goBack()"
    (afterSend)="undefined"
    [form]="form.formFields"
    [serverUrl]="''"
    [dropdownLoadTrigger]="dropdownLoadTrigger"
    [dropdownsFinalized]="dropdownsFinalized"
    [id]="getModel().id ?? ''"
    [request]="getType() === FormRequestTypes.EDIT ? fincasApi.sectoresPUT : fincasApi.sectoresPOST"
    [getRequest]="fincasApi.sectoresGET">
  </app-reactive-form-builder>
</p-panel>